import DeleteOutlined from "@ant-design/icons/DeleteOutlined";
import React from "react";
import useConfirmModal from "common/Modal/useConfirmModal";
import { affiliationService } from "app/services/affiliation.service";
import { displayResultMessage } from "utils/misc";
import { TableActionsEllipsisOutlined } from "features/affiliation/common/styles";
import Dropdown from "common/Dropdown/Dropdown";
import LookIcon from "common/Icons/LookIcon";
import { CircleX } from "lucide-react";
import { useTheme } from "styled-components";
import { MenuTrigger } from "features/affiliation/NewLook/parts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface PayoutsActionsProps {
  payoutId: number;
  /** New look: a 40px trigger for phone rows. */
  largeTrigger?: boolean;
}

const PayoutsActions = ({ payoutId, largeTrigger }: PayoutsActionsProps) => {
  const { isNewLook } = useTheme();
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  const [cancelPayout, { isLoading: cancelLoading }] =
    affiliationService.useCancelPayoutMutation();

  const { openConfirmModal, confirmModalContextHolder } = useConfirmModal({
    loading: cancelLoading,
  });

  const handleCancelPayout = () => {
    return displayResultMessage(
      cancelPayout({
        payout_id: payoutId,
      }).unwrap(),
      t("messages.payout_canceled"),
      t("messages.payout_cancel_failed")
    );
  };

  const menuItems = [
    {
      key: "cancelPayout",
      icon: (
        <LookIcon
          classic={<DeleteOutlined />}
          newLook={<CircleX size={16} strokeWidth={1.75} />}
        />
      ),
      label: t("payouts.cancel_payout"),
      onClick: () =>
        openConfirmModal(
          t("messages.payout_cancel_confirm"),
          handleCancelPayout,
          true
        ),
    },
  ];

  return (
    <>
      <Dropdown
        title={t("payouts.actions")}
        menu={{ items: menuItems }}
        placement="bottomRight"
        trigger={["click"]}
      >
        {isNewLook ? (
          <MenuTrigger $large={largeTrigger} />
        ) : (
          <TableActionsEllipsisOutlined />
        )}
      </Dropdown>
      {confirmModalContextHolder}
    </>
  );
};

export default PayoutsActions;
